import React, { useEffect, useRef, useState } from "react";
import MyAccountLayout from "./MyAccountLayout";
import CustomDatePicker from "../../components/CustomDatePicker";
import moment from "moment";
import { useParams } from "react-router-dom";
import { apiPath } from "../../Utils/apiPath";
import { apiGet } from "../../Utils/apiFetch";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { toFixedWithoutRounding } from "../../Utils/Constant";

const CasinoProfitLoss = () => {
  const previousDate = moment()
    .subtract(1, "day")
    .format("YYYY-MM-DD HH:mm:ss");
  const params = useParams();
  const currentDate = moment().format("YYYY-MM-DD HH:mm:ss");
  const [data, setData] = useState([]);
  const DEFAULT_FILTER = {
    fromPeriod: previousDate,
    toPeriod: currentDate,
    created_by: params?.id,
    userType: "user",
  };
  const [filter, setFilter] = useState(DEFAULT_FILTER);
  const getData = async (activeFilter) => {
    const path = apiPath.profitReportByAllCasino;
    const { status, data: response_users } = await apiGet(path, activeFilter);
    if (status === 200 && response_users.success) {
      setData(response_users.results[0] || []);
    }
  };

  useEffect(() => {
    getData(filter);
  }, [filter]);

  const applyPreset = (preset) => {
    const nextFilter = { ...filter, page: 1, filterByDay: preset };
    if (preset === "today") {
      nextFilter.fromPeriod = moment()
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
      nextFilter.toPeriod = moment().endOf("day").format("YYYY-MM-DD HH:mm:ss");
    } else if (preset === "yesterday") {
      nextFilter.fromPeriod = moment()
        .subtract(1, "day")
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
      nextFilter.toPeriod = moment()
        .subtract(1, "day")
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
    }
    setFilter(nextFilter);
    getData(nextFilter);
  };

  return (
    <MyAccountLayout>
      <div _ngcontent-serverapp-c110 id="report" className="col-center report">
        <router-outlet _ngcontent-serverapp-c110 className="ng-star-inserted" />
        <app-allcasino-pnl _nghost-serverapp-c131 className="ng-star-inserted">
          <div
            _ngcontent-serverapp-c131
            className="box"
            style={{
              "-webkit-align-items": "baseline",
              "-webkit-box-align": "baseline",
              "-ms-flex-align": "baseline",
              "align-items": "baseline",
            }}
          >
            <h2 _ngcontent-serverapp-c131>All Casino Profit &amp; Loss</h2>
          </div>
          <div _ngcontent-serverapp-c131 className="function-wrap">
            <ul _ngcontent-serverapp-c117 className="input-list flowroot">
              <li _ngcontent-serverapp-c117>
                <label _ngcontent-serverapp-c117>Period</label>
              </li>
              <CustomDatePicker filter={filter} setFilter={setFilter} />
              <li>
                <input
                  name="sortCondition"
                  placeholder="Search Market"
                  value={filter.market}
                  onChange={(e) =>
                    setFilter((prev) => ({ ...prev, market: e.target.value }))
                  }
                />
              </li>
              <li>
                <input
                  placeholder="Search Event"
                  value={filter.event}
                  onChange={(e) =>
                    setFilter((prev) => ({ ...prev, event: e.target.value }))
                  }
                />
              </li>
            </ul>
            <ul className="input-list flowroot">
              <li>
                <a
                  id="today"
                  className="btn"
                  onClick={(e) => {
                    e.preventDefault();
                    applyPreset("today");
                  }}
                >
                  Just for today
                </a>
              </li>
              <li>
                <a
                  id="yesterday"
                  className="btn"
                  onClick={(e) => {
                    e.preventDefault();
                    applyPreset("yesterday");
                  }}
                >
                  From yesterday
                </a>
              </li>
              <li>
                <a
                  id="getPL"
                  className="btn-send"
                  onClick={(e) => {
                    e.preventDefault();
                    getData(filter);
                  }}
                >
                  Get P &amp; L
                </a>
              </li>
            </ul>
          </div>
          <div
            _ngcontent-serverapp-c131
            style={{
              display: "flex",
              "-webkit-box-pack": "end",
              "-webkit-justify-content": "flex-end",
              "-ms-flex-pack": "end",
              "justify-content": "flex-end",
              "-webkit-align-items": "center",
              "-webkit-box-align": "center",
              "-ms-flex-align": "center",
              "align-items": "center",
              padding: "4px 0",
            }}
          >
            <div _ngcontent-serverapp-c131 className="spacer" />
          </div>
          <div
            _ngcontent-serverapp-c131
            id="report"
            data-report="profitAndLossReport"
          >
            <div
              _ngcontent-serverapp-c131
              className="table-responsive data-table"
              style={{ overflow: "auto", "white-space": "nowrap" }}
            >
              <table
                _ngcontent-serverapp-c131
                id="table_DL"
                className="table01 table-pnl"
                style={{ display: "table" }}
              >
                <tbody _ngcontent-serverapp-c131>
                  <tr _ngcontent-serverapp-c131>
                    <th _ngcontent-serverapp-c131 className="align-L">
                      {" "}
                      Provider
                    </th>
                    <th _ngcontent-serverapp-c131> Total Stake</th>
                    <th _ngcontent-serverapp-c131> Player P/L</th>
                  </tr>
                </tbody>
                <tbody _ngcontent-serverapp-c131 id="content">
                  <tr _ngcontent-serverapp-c131 id="table_DL">
                    <td _ngcontent-serverapp-c131 className="align-L">
                      {" "}
                      AWC{" "}
                    </td>
                    <td _ngcontent-serverapp-c131 id="_tax2">
                      <div _ngcontent-serverapp-c131>
                        <span _ngcontent-serverapp-c131>
                          {" "}
                          {toFixedWithoutRounding(data?.stakeAmount)}{" "}
                        </span>
                      </div>
                    </td>
                    <td _ngcontent-serverapp-c131 id="_profitLoss">
                      <div _ngcontent-serverapp-c131>
                        <span
                          className={
                            data?.amount > 0 ? "win-text" : "loss-text"
                          }
                          _ngcontent-serverapp-c131
                        >
                          {" "}
                          {toFixedWithoutRounding(data?.amount)}{" "}
                        </span>
                      </div>
                    </td>
                  </tr>

                  <tr _ngcontent-serverapp-c131 className="total">
                    <td _ngcontent-serverapp-c131 className="align-L">
                      Total
                    </td>
                    <td _ngcontent-serverapp-c131 id="_totalStake">
                      <div _ngcontent-serverapp-c131>
                        <span _ngcontent-serverapp-c131>
                          {toFixedWithoutRounding(data?.stakeAmount)}{" "}
                        </span>
                      </div>
                    </td>
                    <td _ngcontent-serverapp-c131 id="_totalPnl">
                      <div _ngcontent-serverapp-c131>
                        <span
                          className={
                            data?.amount > 0 ? "win-text" : "loss-text"
                          }
                          _ngcontent-serverapp-c131
                        >
                          {" "}
                          {toFixedWithoutRounding(data?.amount)}{" "}
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </app-allcasino-pnl>
      </div>
    </MyAccountLayout>
  );
};

export default CasinoProfitLoss;
